import type { Epic } from 'Flux/index.js'
import { catchError, filter, map, switchMap } from 'rxjs/operators'
import { of } from 'rxjs'
import { invitationSlice } from '../../Slice/Invitation/InvitationSlice.js'

export const DeleteInviteEpic: Epic = (action$, state$, { [invitationSlice.name]: invitation, InviteRepository }) => {
  return action$.pipe(
    filter(invitation.deleteInviteRequest.match),
    switchMap((action) => {
      return InviteRepository.deleteInvite(action.payload.inviteId).pipe(
        map(() => invitationSlice.actions.deleteInviteRequestSuccess({ inviteId: action.payload.inviteId })),
        catchError((error) => of(invitationSlice.actions.deleteInviteRequestFailure({ error })))
      )
    })
  )
}
